module.exports = __webpack_public_path__ + "img/step47.d46a09d0.png";